"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainIcon = void 0;
const React = __importStar(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
class DomainIcon extends React.Component {
    render() {
        const commonProps = {
            title: this.props.Domain.Name ? this.props.Domain.Name : undefined
        };
        if (this.props.Domain.IconUrl) {
            return React.createElement("img", Object.assign({ src: this.props.Domain.IconUrl }, commonProps, { className: "domain-icon" }));
        }
        else {
            return React.createElement(react_fontawesome_1.FontAwesomeIcon, Object.assign({ icon: free_solid_svg_icons_1.faCircle }, commonProps));
        }
    }
}
exports.DomainIcon = DomainIcon;
exports.default = DomainIcon;
//# sourceMappingURL=domain-icon.js.map